/**
 * @module cx
 * @package @geenius/adapters/solidjs-solidui
 * @description Provides the lightweight class name composition helper used by
 * the SolidUI component wrappers.
 */

/**
 * Joins class names while ignoring falsy conditional entries.
 *
 * @param classes Class name strings where falsy values are ignored
 * @returns A space-delimited class name string containing only truthy values
 */
export function cx(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(" ");
}
